import { render, staticRenderFns } from "./DayWeekView.vue?vue&type=template&id=ba243dbe"
import script from "./DayWeekView.vue?vue&type=script&lang=ts"
export * from "./DayWeekView.vue?vue&type=script&lang=ts"
import style0 from "./DayWeekView.vue?vue&type=style&index=0&id=ba243dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports